import { render } from "./RefundGoods.vue?vue&type=template&id=570e264d"
import script from "./RefundGoods.vue?vue&type=script&lang=js"
export * from "./RefundGoods.vue?vue&type=script&lang=js"

import "./RefundGoods.vue?vue&type=style&index=0&id=570e264d&lang=scss"

import exportComponent from "D:\\wwwroot\\mld\\vue-source\\mileIsland\\node_modules\\.store\\vue-loader@16.8.3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__